module.exports = __webpack_public_path__ + "static/img/hospital1Pic1.1cc64a21.png";